import React from 'react';
import type { ElementRef, Ref, ReactNode } from 'react';

import { styled, theme } from '@backyard-ui/styles';
import type { StitchesCSS } from '@backyard-ui/styles';

import styles from './Paper.styles';
export interface PaperProps {
  /**
   * The CSS `padding` property
   */
  padding?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';

  /**
   * The CSS `box-shadow` property
   */
  shadow?: keyof typeof theme.shadows;

  /**
   * The CSS `border-radius` property
   */
  radius?: Exclude<keyof typeof theme.radii, 'full'>;

  /**
   * Stitches `css` func
   */
  css?: StitchesCSS;

  /**
   * The ref to the HTML DOM element
   */
  ref?: Ref<HTMLDivElement>;

  /**
   * The children elements
   */
  children: ReactNode;
}

const DEFAULT_TAG = 'div';

const PaperEl = styled(DEFAULT_TAG, styles);

const Paper = React.forwardRef<ElementRef<typeof DEFAULT_TAG>, PaperProps>(
  (props, ref) => {
    return <PaperEl ref={ref} {...props} />;
  }
);

Paper.displayName = 'Paper';

export default Paper;
